import { UPDATE_BUNDLE } from '../';

export interface BundleItem {
  id: string;
  title: string;
  subtitle?: string;
  imageUrl: string;
  defaultPrice: number;
  position: number;
  categories: number[];
  /** Per categoria cliente, le categorie interne i cui item non entrano nello slot. */
  excludedByCategory: Record<number, number[]>;
}

export default function bundle(state: BundleItem[] | null = null, action: { type: string; data: BundleItem[] }) {
  switch (action.type) {
    case UPDATE_BUNDLE:
      return action.data;
    default:
      return state;
  }
}
